const INFORMATIONS_GENERATION_CODE = {
  titleEmplacement: 'Emplacement',
  titleDispositif: 'Emplacement',
  titleMateriel: 'Dispositif',
  titleFace: 'Matériel',
  label: {
    codeEmplacement: 'Code de l\'emplacement',
    codeDispositif: 'Code du dispositif',
    codeMateriel: 'Code du matériel',
    adresse: 'Adresse',
    adresseDispositif: 'Adresse du dispositif',
    insee: 'Code insee',
    inseeDispositif: 'Code insee du dispositif',
    dispositionMateriel: 'Disposition du matériel',
    visibiliteMateriel: 'Visibilité du matériel',
  },
};

export default INFORMATIONS_GENERATION_CODE;
